import React, { useState } from 'react';
import { connect } from 'react-redux';
import ChartItem from './ChartItem';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
ChartJS.register( CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend );

const ChartList = (props) => {
    return (
        <>
            {
                props.chartItemList?.length > 0 && props.chartItemList?.map((item, index) => {
                    return <ChartItem key={index} item={item} />;
                })
            } 
        </>
    )
}

const mapStateToProps = (state) => {
    return { 
        chartItemList: state.businessMonitoringChartsBlock.chartItemList,
    };
};
  
const mapDispatchToProps = {};
  
export default connect(mapStateToProps, mapDispatchToProps)(ChartList);